import React, { useState } from 'react';
import { LoisirsGerer } from './LoisirsGerer';
import { LoisirsAnalytics } from './LoisirsAnalytics';
import { LoisirsConfigurer } from './LoisirsConfigurer';
import { DemoBanner } from './loisirs/DemoBanner';
import type { DemoTarget } from './loisirs/DemoBanner';
import { useLanguage } from '../contexts/LanguageContext';
import { useScreenInit } from '../useScreenInit.js';
type SubTab = 'gerer' | 'analytiques' | 'configurer';
export function LoisirsModule() {
  const screenInit = useScreenInit();
  const {
    t
  } = useLanguage();
  const [activeSubTab, setActiveSubTab] = useState<SubTab>(screenInit.activeSubTab ?? 'gerer');
  /** Section and panel driven by the guided demo, then by the user. */
  const [section, setSection] = useState<'inscriptions' | 'camps' | 'reservations' | 'equipements' | 'acces'>('inscriptions');
  const [panel, setPanel] = useState<string>('ressources');
  const tabs: {
    id: SubTab;
    label: string;
  }[] = [{
    id: 'gerer',
    label: t('Gérer', 'Manage')
  }, {
    id: 'analytiques',
    label: t('Analytiques', 'Analytics')
  }, {
    id: 'configurer',
    label: t('Configurer', 'Configure')
  }];
  const goToDemoStep = (target: DemoTarget) => {
    setActiveSubTab(target.tab);
    if (target.section) setSection(target.section);
    if (target.panel) setPanel(target.panel);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3600" data-mp="y0dn9q8x6i1t">
      <DemoBanner onNavigate={goToDemoStep} data-id="element-3601" data-mp="y2qaahtjbilq" />

      <div className="mb-8" data-id="element-3602" data-mp="t2bzis0jtuk0">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-3603" data-mp="t10vqs73smsw">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-3604" data-mp="17yb9673b42r9">
            {activeSubTab === 'analytiques' ? t('Loisirs Analytics', 'Recreation Analytics') : t('Loisirs', 'Recreation')}
          </h1>
          <nav aria-label={t('Sections du module', 'Module sections')} className="flex items-center gap-2" data-id="element-3605" data-mp="34r3biq2jvevp">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveSubTab(tab.id)} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === tab.id ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-3606" data-mp="3uhbr70fk24rx">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {activeSubTab === 'analytiques' ? <LoisirsAnalytics data-id="element-3607" data-mp="v03xwu1n4whz" /> : activeSubTab === 'configurer' ? <LoisirsConfigurer panel={panel} onPanelChange={setPanel} data-id="element-3608" data-mp="uzc0reseaqpl" /> : <LoisirsGerer section={section} onSectionChange={setSection} data-id="element-3609" data-mp="100htvdpywfzn" />}
    </div>;
}